import { render, staticRenderFns } from "./POrderGridTable.vue?vue&type=template&id=99440368&scoped=true"
import script from "./POrderGridTable.vue?vue&type=script&lang=js"
export * from "./POrderGridTable.vue?vue&type=script&lang=js"
import style0 from "./POrderGridTable.vue?vue&type=style&index=0&id=99440368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99440368",
  null
  
)

export default component.exports